import { ToolCategoriesService } from "@common/client"
import { toolsBaseKey } from "./tools"
import { makeAxiosMutation, makeNoArgsQuery } from "./utils"

export const toolCategoriesBaseKey = ["tool-categories"] as const

export const toolCategoriesQuery = makeNoArgsQuery({
  serviceCall: ToolCategoriesService.listToolCategories,
  queryKey: toolCategoriesBaseKey,
})

export const archivedToolCategoriesQuery = makeNoArgsQuery({
  serviceCall: () =>
    ToolCategoriesService.listToolCategories({ deleted: true }),
  queryKey: [...toolCategoriesBaseKey, "archived"],
})

export const useCreateToolCategoryMutation = makeAxiosMutation({
  serviceCall: ToolCategoriesService.createToolCategory,
  invalidates: () => [toolCategoriesBaseKey],
})

export const useUpdateToolCategoryMutation = makeAxiosMutation({
  serviceCall: ToolCategoriesService.updateToolCategory,
  invalidates: () => [toolCategoriesBaseKey, toolsBaseKey],
})

export const useDeleteToolCategoryMutation = makeAxiosMutation({
  serviceCall: ToolCategoriesService.deleteToolCategory,
  invalidates: () => [toolCategoriesBaseKey],
})

export const useRestoreToolCategoryMutation = makeAxiosMutation({
  serviceCall: ToolCategoriesService.restoreToolCategory,
  invalidates: () => [toolCategoriesBaseKey, toolsBaseKey],
})
